import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { DonBalance } from '~/components/Balance';
import { Don } from '~/components/Don';
import { T } from '~/components/I18n';
import { Confirm, ConfirmProps } from '~/components/Modal/Confirm/Confirm';
import './InsufficientPopup.scss';
import insufficientDon from './insufficientDon.png';
export type InsufficientPopupProps = ConfirmProps & {
  required: number;
  balance: number;
};

// NOTE: may not in use. adventure is not using DON for participation.
export const InsufficientPopup = ({ required, balance, ...props }: InsufficientPopupProps) => {
  const history = useHistory();
  const onConfirm = useCallback(() => {
    history.push('/membership/item/citizen/levelup#myMission');
  }, [history]);
  return (
    <Confirm
      {...props}
      className="insufficient-popup"
      icon={<img src={insufficientDon} alt="not enough DON" />}
      title={<T name="citizen_short_don_popup_title" />}
      description={
        <>
          <T name="citizen_don_in_possession" /> : <DonBalance value={balance} />
          <br />
          <T name="citizen_participation_fee" /> : <Don value={required} /> DON
        </>
      }
      confirmText={<T name="citizen_short_don_popup_confirm" />}
      dismissText={<T name="citizen_button_title_next_time" />}
      onConfirm={onConfirm}
      data-event="impression"
      data-event-category="don_shortage_popup"
      data-event-impression-id="{category}"
    />
  );
};
